import { render, staticRenderFns } from "./MenuBarAbout.vue?vue&type=template&id=7049a0a1&"
import script from "./MenuBarAbout.vue?vue&type=script&lang=js&"
export * from "./MenuBarAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports